import * as z from "zod";

const req = (msg: string) =>
  z.preprocess(
    (v) => (v == null ? "" : v),
    z.string().trim().min(1, msg)
  );

export const addMspProductLicenseFormSchema = z.object({
  // License
  no_of_licenses: z.preprocess(
    (val) => {
      {
        if (val === null || val === undefined || val === "") return undefined;
        const num = Number(val);
        return isNaN(num) ? val : num;
      }
    },
    z.number()
      .min(1, "Number of licenses must be at least 1.")
      .refine(val => !isNaN(val), "Please enter a valid number for licenses.")
  ),

  // Payment
  total_paid_amount: z.preprocess(
    (val) => {
      if (val === null || val === undefined || val === "") return undefined;
      const num = Number(val);
      return isNaN(num) ? val : num;
    },
    z.number()
      .min(0, "Total amount must be a positive number.")
      .refine(val => val > 0, "Total amount must be greater than zero.")
  ),

  discount: z.preprocess(
    (val) => {
      if (val === null || val === undefined || val === "") return undefined;
      const num = Number(val);
      return isNaN(num) ? val : num;
    },
    z.number()
      .min(0, "Discount must be a positive number.")
      .refine(val => !isNaN(val), "Please enter a valid discount amount.")
      .optional()
  ),

  payment_mode: req("Please choose payment mode."),
  transaction_ref: z.string().optional(),
  date_of_payment: req("Please select date of payment."),
  comment: z.string().optional(),

});


export type AddMSPProductLicenseFormValues = z.infer<typeof addMspProductLicenseFormSchema>;